// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"b122d33b","343":"bd15a936","453":"e2958022","962":"0deee488"}[chunkId] + ".chunk.js";
};